export default {
    path: '/dashboard/memberships',
    components: {
        default: () => import('@/modules/member/membership/views/MembershipChange.vue'),
        header: () => import('../../views/memberDashboard/header/index.vue'),
        footer: () => import('../../views/public/footer/index.vue'),
    },
    children: [
        {
            path: '',
            name: 'memberDashboard.memberships',
            meta: {
                middleware: {
                    mustBeAuthenticated: true,
                    mustHasRoles: ['member']
                }
            },

            component: () => import('@/modules/member/membership/views/MembershipChange.vue'),
        }
    ]
}